<!-- ── Cart Overlay ──────────────────────────────────────── -->
<div class="bt-cart-overlay" *ngIf="viewCart" (click)="onToggleCart()" [class.show]="viewCart"></div>

<!-- ── Cart Slide-out Panel ───────────────────────────────── -->
<div class="bt-cart-panel" [class.open]="viewCart">

  <div class="bt-cart-header">
    <div class="bt-cart-header-content">
      <i class="fas fa-shopping-cart bt-cart-icon"></i>
      <h3>{{ t.cartTitle }}</h3>
      <span class="bt-cart-badge" *ngIf="myCart.length > 0">{{ myCart.length }}</span>
    </div>
    <button class="bt-cart-close" (click)="onToggleCart()">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <div class="bt-cart-body">
    <div *ngIf="myCart.length === 0" class="bt-cart-empty fade-in-up">
      <div class="bt-cart-empty-icon">
        <i class="fas fa-shopping-basket"></i>
      </div>
      <h4>{{ t.cartEmpty }}</h4>
      <p>{{ t.cartEmptyHint }}</p>
    </div>

    <div *ngIf="myCart.length > 0" class="bt-cart-items">
      <div class="bt-cart-item" *ngFor="let element of groupedCart; let i = index">
        <div class="bt-cart-item-left">
          <div class="bt-cart-item-icon"><i class="fas fa-ticket-alt"></i></div>
        </div>
        <div class="bt-cart-item-center">
          <h5 class="bt-cart-item-name">{{ element.event }}</h5>
          <div *ngIf="element.typeCar" class="bt-cart-type-label">
            <i class="fas fa-bus"></i> {{ element.typeCar }}
          </div>
          <div *ngIf="element.isRoundTrip" class="bt-cart-round-trip-chip">
            <i class="fas fa-exchange-alt"></i> {{ t.roundTripLabel }}
          </div>
          <div *ngIf="element.isRoundTrip" class="bt-cart-ticket-count">
            <span class="bt-cart-badge">{{ myCart.length }}</span>
            <span class="bt-cart-ticket-count__text">{{ t.ticketsIncludedLabel }}</span>
          </div>
          <div *ngIf="!element.isRoundTrip && element.typeTicket" class="bt-cart-type-label">
            <i class="fas fa-ticket-alt"></i> {{ element.typeTicket }}
          </div>
          <div class="bt-cart-item-details">
            <span class="bt-cart-detail-badge"><i class="far fa-calendar"></i> {{ element.eventDay }}</span>
            <span class="bt-cart-detail-badge"><i class="far fa-clock"></i> {{ element.eventTime }}</span>
          </div>
          <div class="bt-cart-item-location">
            <i class="fas fa-map-marker-alt"></i> {{ element.enclosure }}
            <span class="bt-cart-zone">• {{ element.zone }}</span>
          </div>
        </div>
        <div class="bt-cart-item-right">
          <div class="bt-cart-item-price">${{ element.zonePrice.toFixed(2) }}</div>
          <button class="bt-cart-remove-btn" type="button"
            (click)="confirmRemoveFromCart($event, element)"
            [title]="t.removeButton">
            <i class="far fa-trash-alt"></i> {{ t.removeButton }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="bt-cart-footer" *ngIf="myCart.length > 0">
    <div class="bt-cart-summary">
      <div class="bt-cart-summary-row">
        <span>{{ t.subtotalLabel }}</span><span>${{ subtotal.toFixed(2) }}</span>
      </div>
      <div class="bt-cart-summary-row">
        <span>{{ t.serviceChargeLabel }}</span><span>${{ serviceCharge.toFixed(2) }}</span>
      </div>
      <div class="bt-cart-summary-divider"></div>
      <div class="bt-cart-summary-row bt-cart-summary-total">
        <span>{{ t.totalLabel }}</span><span>${{ total.toFixed(2) }}</span>
      </div>
    </div>
    <div class="bt-cart-actions">
      <button class="bt-cart-btn-secondary" type="button" (click)="onToggleCart()">
        <i class="fas fa-plus"></i> {{ t.addMoreButton }}
      </button>
      <button class="bt-cart-btn-primary" type="button" (click)="onPayment()">
        <span>{{ t.payNowButton }}</span> <i class="fas fa-arrow-right"></i>
      </button>
    </div>
  </div>
</div>

<!-- ── Modal: Se añadió al carrito ───────────────────────── -->
<ng-template #confirmModal let-c="close" let-d="dismiss">
  <div class="cart-confirm-modal" [style.--cart-confirm-accent]="btRecintoColor">
    <div class="cart-confirm-modal__glow cart-confirm-modal__glow--top"></div>
    <div class="cart-confirm-modal__glow cart-confirm-modal__glow--bottom"></div>

    <div class="cart-confirm-modal__badge">
      <i class="fas fa-check-circle"></i>
      <span>{{ t.confirmationBadge }}</span>
    </div>

    <div class="cart-confirm-modal__hero">
      <div class="cart-confirm-modal__icon-shell">
        <div class="cart-confirm-modal__icon-ring"></div>
        <div class="cart-confirm-modal__icon-core">
          <i class="fas fa-shopping-bag"></i>
        </div>
      </div>

      <div class="cart-confirm-modal__headline">
        <h3 class="cart-confirm-modal__title">{{ titleModal }}</h3>
        <p class="cart-confirm-modal__message">{{ message | translateBackendMsg }}</p>
      </div>
    </div>

    <div class="cart-confirm-modal__divider"></div>

    <div class="cart-confirm-modal__tags">
      <div class="cart-confirm-modal__tag">
        <i class="fas fa-bolt"></i>
        <span>{{ t.requestProcessedTag }}</span>
      </div>
      <div class="cart-confirm-modal__tag">
        <i class="fas fa-layer-group"></i>
        <span>{{ t.continueNextStepTag }}</span>
      </div>
    </div>

    <button type="button" class="cart-confirm-modal__cta" (click)="onModalAccept()">
      <span>{{ t.continueButton }}</span>
      <i class="fas fa-arrow-right"></i>
    </button>
  </div>
</ng-template>

<!-- ── Alert: compra incompleta ──────────────────────────── -->
<div class="bt-alert-overlay" *ngIf="showIncompleteAlert" (click)="onAlertCancel()">
  <div class="bt-alert-card" (click)="$event.stopPropagation()">

    <div class="bt-alert-icon">
      <em class="fas fa-exclamation-circle"></em>
    </div>

    <h2 class="bt-alert-title">{{ t.dearUserPrefix }} {{ userName }}</h2>
    <p class="bt-alert-body">
      {{ t.thankYouForPurchase }}
      {{ t.incompletePurchaseNote }}
    </p>

    <!-- Un bloque por cada evento incompleto -->
    <div class="bt-alert-events-scroll">
      <div class="bt-alert-event" *ngFor="let display of incompleteDisplayItems">
        <div class="bt-alert-event-name">
          <em class="fas fa-calendar-alt"></em>
          <span class="bt-alert-event-label">{{ t.eventLabel }}</span>
          {{ display.item.eventName }}
        </div>

        <div class="bt-alert-missing-row">

          <!-- Falta autobús o ambos -->
          <div class="bt-alert-missing-chip bt-alert-missing-chip--bus"
            *ngIf="display.missingType === 'bus' || display.missingType === 'both'">
            <em class="fas fa-bus"></em>
            <span>{{ t.missingBusTicket }}</span>
            <span class="bt-alert-ratio">
              ({{ display.item.personasEvento }} {{ display.item.personasEvento !== 1 ? t.personsInCar : t.personInCar }},
              {{ display.item.personasConBus }} {{ t.busTicketsLabel }})
            </span>
          </div>

          <!-- Falta evento o ambos -->
          <div class="bt-alert-missing-chip bt-alert-missing-chip--event"
            *ngIf="display.missingType === 'event' || display.missingType === 'both'">
            <em class="fas fa-ticket-alt"></em>
            <span>{{ t.missingParkingTicket }}</span>
            <span class="bt-alert-ratio">
              ({{ display.item.personasConBus }} {{ t.withBusLabel }},
              {{ display.item.personasEvento }} {{ t.withParkingLabel }})
            </span>
          </div>

        </div>

        <p class="bt-alert-missing-summary" *ngIf="display.missingType === 'bus'">
          {{ t.recommendAcquirePrefix }} <strong>{{ display.item.personasSinAutobus }}
            {{ display.item.personasSinAutobus !== 1 ? t.busTicketPluralLabel : t.busTicketSingularLabel }}</strong>
        </p>
        <p class="bt-alert-missing-summary" *ngIf="display.missingType === 'event'">
          {{ t.recommendAcquirePrefix }} <strong>{{ display.item.personasBusExtra !== 1 ? t.parkingTicketPluralFor : t.parkingTicketSingularFor }}
            {{ display.item.personasBusExtra }} {{ t.personPlural }}</strong>
        </p>

        <ng-container *ngIf="display.missingType !== 'both'; else bothButtons">
          <button class="bt-alert-btn bt-alert-btn--buy bt-alert-btn--event-buy" type="button"
            (click)="onAlertBuy(display)">
            <em class="fas fa-shopping-cart"></em>
            {{ display.missingType === 'bus' ? t.buyBusButton : t.buyParkingButton }}
          </button>
        </ng-container>
        <ng-template #bothButtons>
          <button class="bt-alert-btn bt-alert-btn--buy bt-alert-btn--event-buy" type="button"
            (click)="onAlertBuy(display, 'bus')">
            <em class="fas fa-bus"></em>
            {{ t.buyBusButton }}
          </button>
          <button class="bt-alert-btn bt-alert-btn--buy bt-alert-btn--event-buy" type="button"
            (click)="onAlertBuy(display, 'event')">
            <em class="fas fa-ticket-alt"></em>
            {{ t.buyParkingButton }}
          </button>
        </ng-template>
      </div>
    </div>

    <!-- Botón cancelar global -->
    <div class="bt-alert-footer">
      <button class="bt-alert-btn bt-alert-btn--cancel" type="button" (click)="onAlertCancel()">
        <em class="fas fa-times"></em>
        {{ t.skipButton }}
      </button>
    </div>

  </div>
</div>

<!-- ── Alert: error al adquirir boleto ───────────────────── -->
<div class="bt-alert-overlay" *ngIf="showErrorAlert" (click)="showErrorAlert = false">
  <div class="bt-alert-card" (click)="$event.stopPropagation()">
    <div class="bt-alert-icon">
      <em class="fas fa-times-circle" style="color:#e53e3e;"></em>
    </div>
    <h2 class="bt-alert-title">{{ t.sorryLabel }}</h2>
    <p class="bt-alert-body">{{ errorAlertMessage }}</p>
    <div class="bt-alert-footer">
      <button class="bt-alert-btn bt-alert-btn--cancel" type="button" (click)="showErrorAlert = false">
        <em class="fas fa-times"></em>
        {{ t.closeButton }}
      </button>
    </div>
  </div>
</div>

<!-- ── Loading: cargando info de boleto ──────────────────── -->
<div class="bt-loading-overlay" *ngIf="loadingBusData">
  <div class="bt-loading-card">
    <div class="bt-loading-spinner"></div>
    <p class="bt-loading-text">{{ 'loadingTicketInfo' | loaderText }}</p>
  </div>
</div>

<div class="bt-page">

  <!-- ══════════════════════════════════════════════════════ -->
  <!-- CASO 1: buyEventMode = true                           -->
  <!-- Selector de auto, evento y zona para comprar estacionamiento   -->
  <!-- ══════════════════════════════════════════════════════ -->
  <ng-container *ngIf="buyEventMode">
    <div class="bt-container">

      <div class="su-event-header">
        <div class="su-event-badge">
          <em class="fas fa-ticket-alt"></em>
          <span>{{ t.buyParkingBadge }}</span>
        </div>
        <h1 class="su-event-title">{{ t.selectTicketTitle }}</h1>
        <p class="su-event-type">{{ t.carEventZoneSubtitle }}</p>
      </div>

      <!-- ── Paso 1: Tipo de automóvil ── -->
      <div class="su-section-label">
        <em class="fas fa-car"></em>
        {{ t.carTypeLabel }}
      </div>

      <div *ngIf="!btSelectedCar" class="bt-car-type-container">
        <div *ngFor="let car of carTypes" class="bt-car-type-card" (click)="btSelectCar(car.name)">
          <div class="bt-car-icon"><i [class]="car.icon" [style.color]="btRecintoColor"></i></div>
          <span>{{ car.name }}</span>
        </div>
      </div>

      <div *ngIf="btSelectedCar" class="bt-car-summary fade-in-up" [style.border-left-color]="btRecintoColor">
        <div class="bt-car-summary__content">
          <div class="bt-car-summary__icon"><i [class]="btSelectedCarIcon" [style.color]="btRecintoColor"></i></div>
          <div class="bt-car-summary__text">
            <span class="bt-car-summary__label">{{ t.selectedCarLabel }}</span>
            <span class="bt-car-summary__value">{{ btSelectedCar }}</span>
          </div>
        </div>
        <button class="bt-summary-edit-btn" type="button"
          (click)="btSelectedCar = null; btSelectedEvent = null; btSelectedZone = null">
          <i class="fas fa-pen"></i>
        </button>
      </div>

      <!-- ── Paso 2: Evento (solo si auto seleccionado) ── -->
      <ng-container *ngIf="btSelectedCar">
        <div class="su-section-label bt-section-mt">
          <em class="fas fa-calendar-alt"></em>
          {{ t.eventLabel }}
        </div>

        <div *ngIf="loadingBusData" class="text-center my-3">
          <div class="bt-loading-spinner" style="width:24px;height:24px;border-width:3px;margin:0 auto 8px;"></div>
          <span style="font-size:0.9rem;color:#555;">{{ 'loadingEvents' | loaderText }}</span>
        </div>

        <div *ngIf="!btSelectedEvent && !loadingBusData" class="bt-event-list fade-in-up">
          <div *ngFor="let evento of btArrayEvents" class="bt-event-card" (click)="btSelectEvento(evento)">
            <div class="bt-event-card__info">
              <span class="bt-event-card__name">{{ evento.chrNombreEvento }}</span>
              <span class="bt-event-card__date">
                <i class="far fa-calendar-alt"></i>
                {{ evento.diaEventoAt | date:"d 'de' MMMM 'del' yyyy" }} — {{ evento.diaEventoAt | date:'h:mm a' }}
              </span>
            </div>
            <i class="fas fa-chevron-right bt-event-card__arrow"></i>
          </div>
          <p *ngIf="btArrayEvents.length === 0 && !loadingBusData" class="text-center text-muted py-3">
            {{ t.noEventsAvailable }}
          </p>
        </div>

        <div *ngIf="btSelectedEvent" class="bt-car-summary fade-in-up" [style.border-left-color]="btRecintoColor">
          <div class="bt-car-summary__content">
            <div class="bt-car-summary__icon"><i class="fas fa-calendar-check" [style.color]="btRecintoColor"></i></div>
            <div class="bt-car-summary__text">
              <span class="bt-car-summary__label">{{ t.selectedEventLabel }}</span>
              <span class="bt-car-summary__value">{{ btSelectedEvent.chrNombreEvento }}</span>
            </div>
          </div>
          <button class="bt-summary-edit-btn" type="button" (click)="btSelectEvento(null)">
            <i class="fas fa-pen"></i>
          </button>
        </div>
      </ng-container>

      <!-- ── Mapa del recinto (aparece al seleccionar evento) ── -->
      <ng-container *ngIf="btSelectedCar && btSelectedEvent && btRecintoLat && btRecintoLng">
        <div class="su-section-label bt-section-mt">
          <em class="fas fa-map-marker-alt"></em>
          {{ t.enclosureLocationLabel }}
        </div>
        <div class="bt-recinto-map-container fade-in-up">
          <div id="bt-recinto-map" class="bt-recinto-map"></div>
          <div class="bt-map-loader" *ngIf="btLoadingAddress">
            <div class="bt-map-loader__spinner"></div>
            <span class="bt-map-loader__text">{{ 'loadingAvailableParkingZone' | loaderText }}</span>
          </div>
        </div>
      </ng-container>

      <!-- ── Paso 3: Zona (solo si evento seleccionado) ── -->
      <ng-container *ngIf="btSelectedCar && btSelectedEvent">
        <div class="su-section-label bt-section-mt">
          <em class="fas fa-map-marker-alt"></em>
          {{ t.parkingBoardLabel }}
        </div>

        <div *ngIf="btLoadingZones" class="text-center my-3">
          <div class="bt-loading-spinner" style="width:24px;height:24px;border-width:3px;margin:0 auto 8px;"></div>
          <span style="font-size:0.9rem;color:#555;">{{ 'loadingZones' | loaderText }}</span>
        </div>

        <!-- Zonas pre-cargadas desde respuesta de autobús -->
        <div *ngIf="btPreloadedZonesList.length > 0" class="bt-zone-bubbles fade-in-up">
          <div *ngFor="let zona of btPreloadedZonesList" class="bt-zone-bubble"
            [class.bt-zone-bubble--selected]="btSelectedZone === zona.idZonaEstacionamiento"
            [style.background-color]="btSelectedZone === zona.idZonaEstacionamiento ? btRecintoColor : ''"
            [style.border-color]="btSelectedZone === zona.idZonaEstacionamiento ? btRecintoColor : ''"
            [style.color]="btSelectedZone === zona.idZonaEstacionamiento ? '#fff' : ''"
            (click)="btSelectPreloadedZone(zona)">
            <span [style.color]="btSelectedZone === zona.idZonaEstacionamiento ? '#fff' : ''">{{ zona.horarioIda ||
              zona.chrNombreZona }}</span>
            <i *ngIf="btSelectedZone === zona.idZonaEstacionamiento" class="fas fa-check-circle" style="color:#fff"></i>
          </div>
        </div>

        <!-- Zonas desde API (flujo normal) -->
        <div *ngIf="!btLoadingZones && btListZonas.length > 0 && btPreloadedZonesList.length === 0"
          class="bt-zone-bubbles fade-in-up">
          <div *ngFor="let zona of btListZonas" class="bt-zone-bubble"
            [class.bt-zone-bubble--selected]="btSelectedZone === zona.tblZona.idZona"
            [style.background-color]="btSelectedZone === zona.tblZona.idZona ? btRecintoColor : ''"
            [style.border-color]="btSelectedZone === zona.tblZona.idZona ? btRecintoColor : ''"
            [style.color]="btSelectedZone === zona.tblZona.idZona ? '#fff' : ''"
            (click)="btSelectZone(zona.tblZona.idZona, zona.nameZona)">
            <span [style.color]="btSelectedZone === zona.tblZona.idZona ? '#fff' : ''">{{ zona.nameZona }}</span>
            <i *ngIf="btSelectedZone === zona.tblZona.idZona" class="fas fa-check-circle" style="color:#fff"></i>
          </div>
        </div>

        <!-- Detalle de zona seleccionada -->
        <ng-container *ngIf="btSelectedZone">

          <!-- Contador de pasajeros -->
          <div class="su-section-label bt-section-mt">
            <em class="fas fa-users"></em>
            {{ t.passengersInCarQuestion }}
          </div>
          <div class="bt-person-counter fade-in-up">
            <em class="fas fa-users bt-person-counter__icon"></em>
            <button class="bt-person-counter__btn" type="button" [disabled]="btPersonCount <= 1"
              (click)="btDecrementPersonCount()">
              <em class="fas fa-minus"></em>
            </button>
            <input class="bt-person-counter__input" type="number" [min]="1" [(ngModel)]="btPersonCount"
              (change)="btClampPersonCount()">
            <button class="bt-person-counter__btn" type="button" (click)="btIncrementPersonCount()">
              <em class="fas fa-plus"></em>
            </button>
          </div>

          <div *ngIf="!btLoadingAddress && (btSelectedZoneAddress || btSelectedZoneReference)"
            class="bt-zone-detail fade-in-up">
            <div *ngIf="btSelectedZoneAddress" class="bt-zone-detail__row">
              <i class="fas fa-map-marker-alt" [style.color]="btRecintoColor"></i>
              <div>
                <span class="bt-zone-detail__label">{{ t.addressLabel }}</span>
                <span class="bt-zone-detail__value">{{ btSelectedZoneAddress }}</span>
              </div>
            </div>
            <div *ngIf="btSelectedZoneReference" class="bt-zone-detail__row">
              <i class="fas fa-directions" [style.color]="btRecintoColor"></i>
              <div>
                <span class="bt-zone-detail__label">{{ t.referenceLabel }}</span>
                <span class="bt-zone-detail__value">{{ btSelectedZoneReference }}</span>
              </div>
            </div>
          </div>

          <!-- Precio y disponibilidad -->
          <div *ngFor="let z of btDetailZonas" class="bt-zone-info fade-in-up">
            <div class="bt-zone-info__row">
              <span><i class="fas fa-tag" [style.color]="btRecintoColor"></i> {{ t.priceLabel }}</span>
              <strong [style.color]="btRecintoColor">{{ btIsFree ? t.freeLabel : ('$' + z.Costo) }}</strong>
            </div>
            <div class="bt-zone-info__row" *ngIf="btLugaresDisponibles !== undefined">
              <span><i class="fas fa-parking" [style.color]="btRecintoColor"></i> {{ t.availableLabel }}</span>
              <strong [style.color]="btRecintoColor">{{ btLugaresDisponibles }}</strong>
            </div>
          </div>

          <!-- Términos -->
          <div class="bt-terms fade-in-up">
            <input type="checkbox" id="bt-terminos" [(ngModel)]="btTerminos" [style.accent-color]="btRecintoColor"
              style="width:18px;height:18px;cursor:pointer;margin-right:10px;">
            <label for="bt-terminos" style="margin:0;cursor:pointer;font-size:0.9rem;">
              {{ t.acceptTermsPrefix }}
              <strong [style.color]="btRecintoColor">{{ t.termsAndConditions }}</strong>
            </label>
          </div>

          <!-- Acciones -->
          <div class="su-actions-confirm">
            <button class="su-btn-confirm" type="button" [style.background-color]="btRecintoColor"
              [style.border-color]="btRecintoColor" [disabled]="!btTerminos || btLoading || btLugaresDisponibles === 0"
              (click)="btCart()">
              <em [class]="btIsFree ? 'fas fa-ticket-alt' : 'fas fa-shopping-cart'"></em>
              {{ btLoading ? t.processingLabel : (btLugaresDisponibles === 0 ? t.noAvailabilityLabel : (btIsFree ?
              t.acquireTicketButton : t.addToCartButton)) }}
            </button>
            <button class="su-btn-secondary" type="button" (click)="btCancel()">
              <em class="fas fa-times"></em>
              {{ t.cancelButton }}
            </button>
          </div>
        </ng-container>
      </ng-container>

    </div>
  </ng-container>

  <!-- ══════════════════════════════════════════════════════ -->
  <!-- CASO 2: multipleAreaTicket = true                     -->
  <!-- Muestra selector de horario / zona de autobús         -->
  <!-- ══════════════════════════════════════════════════════ -->
  <ng-container *ngIf="isMultipleArea && multipleAreaResponse">

    <div class="bt-container">

      <!-- Header del evento -->
      <div class="su-event-header">
        <div class="su-event-badge su-event-badge--area">
          <em class="fas fa-map-marker-alt"></em>
          <span>{{ t.buyBusBadge }}</span>
        </div>
        <p class="su-event-label">{{ t.yourEventIs }}</p>
        <h1 class="su-event-title">{{ multipleAreaResponse.nameEvent }}</h1>
        <div class="su-event-meta">
          <p class="su-event-label su-event-label--counter">{{ t.howManyPeopleQuestion }}</p>
          <br>
          <div class="bt-person-counter">
            <em class="fas fa-users bt-person-counter__icon"></em>
            <span class="bt-person-counter__label">
              {{ multipleAreaResponse.numberPerson }}
              {{ multipleAreaResponse.numberPerson === 1 ? t.personSingular : t.personPlural }}
            </span>
          </div>
          <div class="su-parking-zone" *ngIf="multipleAreaResponse.nameZone">
            <em class="fas fa-parking"></em>
            <span>{{ t.yourParkingSpotIs }} <strong>{{ multipleAreaResponse.nameZone }}</strong></span>
          </div>
        </div>
      </div>

      <!-- ── Banner insistente: debe comprar autobús ── -->
      <div class="su-bus-warning">
        <div class="su-bus-warning__icon">
          <em class="fas fa-exclamation-triangle"></em>
        </div>
        <div class="su-bus-warning__body">
          <p class="su-bus-warning__title">{{ t.completePurchaseTitle }}</p>
          <p class="su-bus-warning__text">
            {{ t.busTicketIncludesPrefix }}
            <strong>{{ multipleAreaResponse.numberPerson }}
              {{ multipleAreaResponse.numberPerson === 1 ? t.personSingular : t.personPlural }}</strong>.
            {{ t.needToAcquirePrefix }}
            <strong>{{ multipleAreaResponse.numberPerson }} {{ multipleAreaResponse.numberPerson === 1 ? t.busTicketSingularLabel :
              t.busTicketPluralLabel }}</strong>
            {{ t.boardingTransportSuffix }}
          </p>
          <ul class="su-bus-warning__list">
            <li>
              <em class="fas fa-times-circle su-bus-warning__list-icon su-bus-warning__list-icon--no"></em>
              {{ t.withoutBusTicketPrefix }} <strong>{{ t.cannotBoardLabel }}</strong> {{ t.transportServiceLabel }}
            </li>
            <li>
              <em class="fas fa-arrow-down su-bus-warning__list-icon su-bus-warning__list-icon--yes"></em>
              {{ t.selectScheduleBelow }}
            </li>
          </ul>
        </div>
      </div>

      <!-- ── Zona confirmada: panel de éxito ── -->
      <ng-container *ngIf="zonaConfirmed; else zonaSelectorBlock">
        <div class="su-confirmed-panel">
          <div class="su-confirmed-icon">
            <em class="fas fa-check-circle"></em>
          </div>
          <h2 class="su-confirmed-title">{{ t.scheduleRegisteredTitle }}</h2>
          <p class="su-confirmed-text">
            {{ t.scheduleSelectedPrefix }}
            <strong>{{ selectedZona.horarioIda }}</strong>
            {{ t.forPrefix }} <strong>{{ multipleAreaResponse.numberPerson }}
              {{ multipleAreaResponse.numberPerson === 1 ? t.personSingular : t.personPlural }}</strong>.
            {{ t.busTicketRequestedSuffix }}
          </p>
          <div class="su-actions-confirm">
            <button class="su-btn-secondary" type="button" (click)="onUserTickets()">
              <em class="fas fa-ticket-alt"></em>
              {{ t.viewMyTicketsButton }}
            </button>
            <button class="su-btn-secondary" type="button" (click)="onHome()">
              <em class="fas fa-times"></em>
              {{ t.cancelButton }}
            </button>
          </div>
        </div>
      </ng-container>

      <!-- ── Selector de zona (se oculta al confirmar) ── -->
      <ng-template #zonaSelectorBlock>

        <!-- Paso 1: Chips de horario agrupados por autobús -->
        <div class="su-section-label">
          <em class="far fa-clock"></em>
          {{ t.selectBusScheduleLabel }}
        </div>

        <ng-container *ngFor="let zoneGroup of multipleAreaResponse.buses">
          <div class="bt-bus-section">
            <div class="bt-bus-header">
              <span class="bt-bus-name">{{ zoneGroup.zone }}</span>
            </div>
            <ng-container *ngFor="let busCompany of zoneGroup.buses">
              <div class="bt-bus-company-label">
                <em class="fas fa-bus"></em> {{ busCompany.name }}
              </div>
              <div class="bt-horario-grid">
                <button class="bt-horario-chip" [class.bt-horario-chip--selected]="selectedZona?.id === horario.id"
                  *ngFor="let horario of busCompany.horarios" type="button" (click)="selectZona(horario)">
                  <span class="bt-horario-chip__name">{{ horario.horarioIda }}</span>
                  <span class="bt-horario-chip__sub" *ngIf="selectedZona?.id === horario.id">
                    {{ t.returnLabel }} {{ horario.horarioRegreso }}
                  </span>
                  <em class="fas fa-check-circle bt-horario-chip__check" *ngIf="selectedZona?.id === horario.id"></em>
                </button>
              </div>
            </ng-container>
          </div>
        </ng-container>

        <!-- Paso 2: Contador de boletos (aparece al seleccionar horario) -->
        <ng-container *ngIf="selectedZona">
          <div class="su-section-label bt-horario-label">
            <em class="fas fa-ticket-alt"></em>
            {{ t.howManyBusTicketsQuestion }}
          </div>
          <div class="bt-person-counter">
            <em class="fas fa-ticket-alt bt-person-counter__icon"></em>
            <button class="bt-person-counter__btn" type="button" [disabled]="selectedPersonCount <= 1"
              (click)="decrementPersonCount()">
              <em class="fas fa-minus"></em>
            </button>
            <input class="bt-person-counter__input" type="number" [min]="1" [(ngModel)]="selectedPersonCount"
              (change)="clampPersonCount()">
            <button class="bt-person-counter__btn" type="button" (click)="incrementPersonCount()">
              <em class="fas fa-plus"></em>
            </button>
          </div>
        </ng-container>

        <div class="col-md-12 mb-3 fade-in-up" *ngIf="isMultipleArea && selectedZona && busMessages.length > 0">
          <div class="bus-messages-wrapper">
            <div class="bus-messages-header" [style.background-color]="btRecintoColor">
              <i class="fas fa-info-circle bus-messages-icon"></i>
              <span class="bus-messages-title">{{ t.importantInfoTitle }}</span>
            </div>
            <div class="bus-messages-body">
              <div class="bus-message-item" *ngFor="let msg of busMessages">
                <i class="fas fa-exclamation-triangle bus-message-bullet" [style.color]="btRecintoColor"></i>
                <p class="bus-message-text">{{ getLocalizedMessageText(msg) }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Resumen de selección -->
        <div class="su-selection-summary" *ngIf="selectedZona">
          <em class="fas fa-check-circle su-summary-icon"></em>
          <div>
            <p class="su-summary-label">{{ t.selectedScheduleLabel }}</p>
            <p class="su-summary-value">{{ selectedZona.horarioIda }}</p>
            <p class="su-summary-label" *ngIf="selectedBusPrice > 0">{{ t.priceLabel }}</p>
            <p class="su-summary-value" *ngIf="selectedBusPrice > 0">
              ${{ selectedBusPrice.toFixed(2) }}
              <span *ngIf="selectedPersonCount > 1"> x {{ selectedPersonCount }} = ${{ selectedBusTotal.toFixed(2) }}</span>
            </p>
          </div>
        </div>

        <!-- Acciones -->
        <div class="su-actions-confirm">
          <button class="su-btn-confirm" type="button" [disabled]="!selectedZona" (click)="onConfirmZona()">
            <em class="fas fa-bus"></em>
            {{ selectedZona ? t.buyBusTicketAction : t.selectScheduleFirstLabel }}
          </button>
          <button class="su-btn-secondary" type="button" (click)="onHome()">
            <em class="fas fa-times"></em>
            {{ t.cancelButton }}
          </button>
        </div>

      </ng-template>

    </div>
  </ng-container>

  <!-- ══════════════════════════════════════════════════════ -->
  <!-- ESTADO VACÍO: sin boletos pendientes                  -->
  <!-- ══════════════════════════════════════════════════════ -->
  <ng-container *ngIf="!isBusTicket && !buyEventMode && !isMultipleArea && !loadingBusData && !showIncompleteAlert">
    <div class="bt-empty-state">
      <div class="bt-empty-illustration">
        <div class="bt-empty-circle bt-empty-circle--outer"></div>
        <div class="bt-empty-circle bt-empty-circle--inner"></div>
        <div class="bt-empty-icon-wrapper">
          <i class="fas fa-ticket-alt bt-empty-icon"></i>
        </div>
      </div>

      <div class="bt-empty-content">
        <h2 class="bt-empty-title">{{ t.noPendingTicketsTitle }}</h2>
        <p class="bt-empty-desc">
          {{ t.noIncompleteText1 }}<br>
          {{ t.noIncompleteText2 }}
        </p>
      </div>

      <div class="bt-empty-steps">
        <div class="bt-empty-step">
          <div class="bt-empty-step-icon"><i class="fas fa-map-marker-alt"></i></div>
          <span>{{ t.chooseCityStep }}</span>
        </div>
        <div class="bt-empty-step-arrow"><i class="fas fa-chevron-right"></i></div>
        <div class="bt-empty-step">
          <div class="bt-empty-step-icon"><i class="fas fa-building"></i></div>
          <span>{{ t.selectEnclosureStep }}</span>
        </div>
        <div class="bt-empty-step-arrow"><i class="fas fa-chevron-right"></i></div>
        <div class="bt-empty-step">
          <div class="bt-empty-step-icon"><i class="fas fa-calendar-check"></i></div>
          <span>{{ t.buyTicketStep }}</span>
        </div>
      </div>

      <div class="bt-empty-actions">
        <button class="bt-empty-btn-primary" type="button" (click)="onHome()">
          <i class="fas fa-search"></i>
          {{ t.exploreEventsButton }}
        </button>
        <button class="bt-empty-btn-secondary" type="button" (click)="onUserTickets()">
          <i class="fas fa-ticket-alt"></i>
          {{ t.viewMyTicketsButton }}
        </button>
      </div>
    </div>
  </ng-container>

</div>
